import { createAsyncSlice } from 'store/createAsyncSlice';
import { sendWireDisbursementAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: sendWirePushSlice, asyncAction: sendWirePushAction } = createAsyncSlice(
  'sendWirePushSlice',
  sendWireDisbursementAsync
);
